import ClientRequestEdit from "../Views/ClientRequest/ClientRequestEdit.vue";
import ClientRequestCreate from "../Views/ClientRequest/ClientRequestCreate.vue";
import ClientRequestShow from "../Views/ClientRequest/ClientRequestShow.vue";
import ClientRequestList from "../Views/ClientRequest/ClientRequestList.vue";
import ClientRequestOtherList from "../Views/ClientRequest/ClientRequestOtherList.vue";
import ClientRequestAgenda from "../Views/Event/ClientRequestAgenda.vue";
import { MODULES } from "../Constants/modules.js";
import { adminGuard } from "./guards.js";

export const clientRequestRoutes = [
    {
        path: "/client-requests/edit/:id",
        name: "client-requests.edit",
        component: ClientRequestEdit,
        meta: {
                module: MODULES.CLIENT_REQUESTS,
            menu: {
                parent: 'client-requests',
                child: "client-requests.list",
            },
            breadcrumb: {
                title: "Demandes clients",
                nav: {
                    all: {
                        active: "Modification",
                        inactive: [{
                            title: "Toutes les demandes",
                            link: {name: 'client-requests.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/client-requests/create",
        name: "client-requests.create",
        component: ClientRequestCreate,
        meta: {
                module: MODULES.CLIENT_REQUESTS,
            menu: {
                parent: 'client-requests',
                child: "client-requests.list",
            },
            breadcrumb: {
                title: "Demandes clients",
                nav: {
                    all: {
                        active: "Création",
                        inactive: [{
                            title: "Toutes les demandes",
                            link: {name: 'client-requests.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/client-requests/:id",
        name: "client-requests.show",
        component: ClientRequestShow,
        meta: {
                module: MODULES.CLIENT_REQUESTS,
            menu: {
                parent: 'client-requests',
                child: "client-requests.list",
            },
            breadcrumb: {
                title: "Demandes clients",
                nav: {
                    all: {
                        active: "Détails de la demande",
                        inactive: [{
                            title: "Toutes les demandes",
                            link: {name: 'client-requests.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/client-requests",
        name: "client-requests.list",
        component: ClientRequestList,
        meta: {
                module: MODULES.CLIENT_REQUESTS,
            menu: {
                parent: 'client-requests',
                child: "client-requests.list",
            },
            breadcrumb: {
                title: "Demandes clients",
                nav: {
                    all: {
                        active: "Toutes les demandes",
                        inactive: null
                    }
                }
            }
        },
    },
    {
        path: "/client-requests-agenda",
        name: "client-requests.agenda",
        component: ClientRequestAgenda,
        meta: {
                module: MODULES.CLIENT_REQUESTS,
            menu: {
                parent: 'client-requests',
                child: "client-requests.agenda",
            },
            breadcrumb: {
                    title: "Agenda RDV",
                nav: {
                    all: {
                        active: "Agenda RDV",
                        inactive: null
                    }
                }
            }
        },
    },
    {
        path: "/client-request-others/:id",
        name: "client-request-others.show",
        component: ClientRequestShow,
        meta: {
                module: MODULES.CLIENT_REQUESTS,
            menu: {
                parent: 'client-request-others',
                child: null
            },
            breadcrumb: {
                title: "Autres demandes",
                nav: {
                    all: {
                        active: "Détails de la demande",
                        inactive: [{
                            title: "Toutes les autres demandes",
                            link: {name: 'client-request-others.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/client-request-others",
        name: "client-request-others.list",
        component: ClientRequestOtherList,
        beforeEnter: adminGuard,
        meta: {
                module: MODULES.CLIENT_REQUESTS,
            menu: {
                parent: 'client-request-others',
                child: null
            },
            breadcrumb: {
                title: "Autres demandes",
                nav: {
                    all: {
                        active: "Toutes les autres demandes",
                        inactive: null
                    }
                }
            }
        },
    }
];
